import {
  LeftNav,
  Modal,
  Notification,
  SidebarSelection,
  Snackbar,
} from '@trucktrax/trucktrax-common';
import { ModalType } from '@trucktrax/trucktrax-common/build/constants';
import {
  DriverDto,
  PermissionAccess,
  ProductLine,
  QualityFactorDto,
  RegionDto,
  TruckDto,
  UrlKeyDto,
  UserRegionDto,
  VoidFunc,
} from '@trucktrax/trucktrax-ts-common';
import axios from 'axios';
import isEqual from 'lodash/isEqual';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Route, Switch } from 'react-router-dom';

import styles from './App.module.css';
import logoAdminSvg from './assets/img/logosAdmin.svg';
import logoGeotraxSvg from './assets/img/logosGeotrax.svg';
import IncomingMaterialsSubscription from './components/geotrax/incomingMaterials/IncomingMaterialsSubscription';
import IncomingTicketsPopover from './components/geotrax/incomingMaterials/IncomingTicketsPopover';
import TicketsPopover from './components/geotrax/ticketing/TicketsPopover';
import NotFoundView from './components/notFound/NotFoundView';
import NotebookPopover from './components/scaletrax/NotebookPopover';
import MessageCenterContainer from './components/shared/messages/MessageCenterContainer';
import MessageCenterPopover from './components/shared/messages/MessageCenterPopover';
import RedirectRoute from './components/shared/routing/RedirectRoute';
import RouteWithSubRoutes from './components/shared/routing/RouteWithSubRoutes';
import { MESSAGE_WINDOW, NOT_FOUND_PATH } from './constants/apiConstants';
import {
  ADMIN_CURRENT_REGION,
  ADMIN_SELECTED_PRODUCT_LINE,
  CANCEL_LABEL,
  CURRENT_REGION,
  DEFAULT,
  GEOTRAX_ROUTE,
  TRUCKTRAX_GEO_FLAG,
  IDLE_TIMEOUT_BODY,
  INCOMING_MATERIALS_FLAG,
  INCOMING_MATERIALS_ROUTE,
  LOGOUT,
  MESSAGE_SELECTED,
  INCOMING_TICKETS_SELECTED,
  NOTEBOOK_SELECTED,
  NotificationType,
  SELECTED_PRODUCT_LINE,
  SIDENAV_REFRESH_IN_MILLISECONDS,
  TICKETS_SELECTED,
} from './constants/appConstants';
import {
  IS_MESSAGE_WINDOW_OPEN,
  OPEN_SIDEBAR_MESSAGES,
  SELECTED_PLANT_URLS,
} from './constants/localStorageConstants';
import {
  AdminCategory,
  adminNavItems,
  categoriesForAdmin,
  featureFlagVehicleNavItem,
  geotraxNavItems,
  GEOZONES_TEXT,
  NavItem,
  PLANTS_TEXT,
  TRUCKS_TEXT,
  VEHICLE_TYPES_TEXT,
  VEHICLES_TEXT,
} from './constants/navConstants';
import {
  adminRouteNotFound,
  docsRouteNotFound,
  getPanelProps,
  mapRouteNotFound,
  mapRouteRedirect,
  RouteInfo,
} from './routes';
import { refreshGeoTraxState } from './services/appService';
import { logOut } from './services/authService';
import { setReduxAllDriverList, setReduxDriverList } from './services/driversService';
import IdleService from './services/idleService';
import { getMapview } from './services/mapviewsService';
import { getInboxMessages, messageSocketInit } from './services/messagesService';
import {
  adminPermissionForUserInCurrentRegion,
  fetchPermissionsListByUserUrl,
} from './services/permissionsService';
import { fetchPlantListAndMapFilters } from './services/plantsService';
import {
  setPrimaryProductLine,
  setSecondaryProductLine,
  setSecondaryProductLines,
  setSelectedProductLine,
} from './services/productLinesService';
import { fetchAssignedRegionList, setCurrentRegion } from './services/regionsService';
import { ticketSocketInit } from './services/ticketsService';
import { setReduxAllTruckList, setReduxTruckList } from './services/trucksService';
import { fetchUsers } from './services/usersService';
import { ReduxState } from './store';
import { setCurrentAppName } from './store/actions/appActions';
import { setSessionId, setUserFullName } from './store/actions/authActions';
import { closeModal, openModal } from './store/actions/errorModalActions';
import geotraxPageSelected from './store/actions/geotraxActions';
import { toggleMapFilter } from './store/actions/mapFilterActions';
import {
  MarkerInfo,
  refreshPositions,
  selectMarker,
  setActiveMarkers,
} from './store/actions/mapviewActions';
import setSidebarSelected, {
  setOpenStateMap,
  toggleExternalTrucksDropdownIsOpen,
  toggleGuideDropdownIsOpen,
  toggleTrucksDropdownIsOpen,
} from './store/actions/sidebarActions';
import {
  closeSnackbar,
  closeSnackbarNotification,
  openSnackbar,
  SnackbarOptions,
} from './store/actions/snackbarActions';
import { AppName } from './store/reducers/appReducer';
import {
  SnackbarNotificationState,
  SnackbarState,
} from './store/reducers/globalComponentsReducers';
import { PlantFilterOption } from './store/reducers/mapFilterReducers';
import { MessageCenterState } from './store/reducers/messageCenterReducers';
import {
  DriverDetail,
  getAllDriversWithDetails,
  getDriversWithDetails,
} from './store/selectors/messageSelectors';
import { selectedPlantUrlsSelector } from './store/selectors/plantSelectors';
import {
  ConnectedDispatchFunction,
  ConnectedFunction,
  MapMarker,
  ModalOptions,
  PositionDetailsDto,
  SidebarTitleType,
  TruckTraxApps,
} from './types';
import appVersionAndEnvString, { noop } from './util/appUtil';
import { getTokens } from './util/authUtil';
import { isFeatureFlagEnabled } from './util/featureFlagUtil';
import {
  appSelectorActionItems,
  incomingTicketingActionItems,
  messagesActionItems,
  notebookActionItems,
  ticketingActionItems,
  withIncomingMaterialsNotice,
  INCOMING_MATERIALS_NAV_KEY,
} from './util/navUtil';
import { hasAppAccessInAnyRegion, RegionAccessMap } from './util/permissionUtil';
import { getTruckToDriverMap } from './util/positionsUtil';
import {
  getPrimaryProductLineFromToken,
  getSecondaryProductLineFromToken,
  getSecondaryProductLinesFromToken,
} from './util/userUtil';
import { activeMarkersSelector } from './store/selectors/markerSelectors';
import { getCurrentRegionFromLocalStorage } from './store/reducers/regionReducers';
import { getProductLineFromLocalStorage } from './store/reducers/productLineReducers';

const PanelLabelWrapper = (route: any) =>
  route.panelLabel ? <h3 className="page-title">{route.panelLabel}</h3> : <></>;

export const renderSidebarInnerComponents =
  (appProps: AppPropsForPanels) => (route: RouteInfo, index: number) => {
    const PanelContent = route.panelComponent;
    const panelProps = getPanelProps(appProps, route);
    return (
      PanelContent && (
        <Route
          key={`${route.path.split('/')[1]}-content-${index}`}
          path={route.path}
          render={() => <PanelContent test={route.panelLabel} {...panelProps} />}
        />
      )
    );
  };

export class App extends Component<AppProps, AppState> {
  static defaultProps: Partial<AppProps> = {
    modalType: DEFAULT,
    acceptDialog: noop,
    selectedMarker: undefined,
    positions: [],
    messageSubscription: [
      {
        unsubscribe: () => {},
      },
    ],
    regions: [
      {
        name: '',
        url: '',
        archived: false,
        deleted: false,
        id: 0,
      },
    ],
    currentRegion: { url: '', defaultRegion: false, name: '' },
    drivers: [],
    dataTestCancel: undefined,
    dataTestOk: undefined,
    routes: [],
    sidebarSelection: undefined,
    currentTicketQualityFactors: [],
    acceptText: undefined,
    selectedProductLine: ProductLine.None,
    primaryProductLine: ProductLine.None,
    secondaryProductLine: ProductLine.None,
    secondaryProductLines: [],
    userPermission: {},
    idleTime: 120,
    sessionId: null,
    userUrl: undefined,
    cancelText: undefined,
    disabled: false,
    noActions: false,
    geotraxPage: undefined,
  };

  constructor(props: AppProps) {
    super(props);

    this.state = {
      adminAccess: [],
      isTicketsOpen: false,
    };
  }

  signal = axios.CancelToken.source();

  primaryProductLine: ProductLine | null = null;

  secondaryProductLine: ProductLine | null = null;

  secondaryProductLines: ProductLine[] | null = [];

  selectedProductLine: ProductLine | null = null;

  trucksInterval?: NodeJS.Timeout;

  userFullName: string = '';

  componentDidMount() {
    const isWindowOpen = window.localStorage.getItem(IS_MESSAGE_WINDOW_OPEN);
    // Event listener to local storage changes
    window.addEventListener('storage', event => {
      // Check if the a local storage change
      if (event.storageArea !== localStorage) return;
      this.handleStorageChange(event);
    });
    const { idleTime } = this.props;
    new IdleService().init(idleTime ?? 120, this.handleIdleTime);
    this.startTrucksInterval();

    const { accessToken } = getTokens();
    this.primaryProductLine = getPrimaryProductLineFromToken(accessToken!) || null;
    this.secondaryProductLine = getSecondaryProductLineFromToken(accessToken!) || null;
    this.secondaryProductLines = getSecondaryProductLinesFromToken(accessToken!) || null;
    this.selectedProductLine = localStorage.getItem(SELECTED_PRODUCT_LINE) as ProductLine;
    this.props.setPrimaryProductLine(this.primaryProductLine ?? ProductLine.None);
    this.props.setSecondaryProductLine(this.secondaryProductLine ?? ProductLine.None);
    this.props.setSecondaryProductLines(this.secondaryProductLines ?? []);

    if (isWindowOpen !== 'true') {
      this.props.setSelectedProductLine(
        this.selectedProductLine ?? this.primaryProductLine ?? ProductLine.None,
      );
    }
    this.props.setUserFullName(this.userFullName);

    this.props.fetchAssignedRegionList(this.socketInit, this.props.getMapview);
    if (this.props.currentRegion?.url) {
      this.fetchGeoTraxData();
    }

    this.initializePermissions();
    this.updateAllDrivers();
    this.updateAllTrucks();
    this.updateTicketsOpen();
    this.props.setCurrentAppName(this.normalizedAppPath as AppName);

    // Initialize Redux state from localStorage on mount
    this.initializeFromLocalStorage();
  }

  handleIdleTime = () => {
    if (getTokens().accessToken === null) {
      return;
    }
    const { sessionId } = this.props;
    this.props.logOut();
    if (sessionId !== null) {
      this.props.openSnackbar({
        snackbarBody: IDLE_TIMEOUT_BODY,
        snackbarType: DEFAULT,
      });
      this.props.setSessionId('');
    }
  };

  async componentDidUpdate(prevProps: AppProps) {
    const regionChanged = !isEqual(this.props.currentRegion, prevProps.currentRegion);
    const productLineChanged = this.props.selectedProductLine !== prevProps.selectedProductLine;
    const userPermissionChanged = this.props.userPermission !== prevProps.userPermission;

    if (regionChanged) {
      await this.initializePermissions();
      this.fetchGeoTraxData();
      this.setAdminCategoryAccess();
      this.updateAllTrucks();
      this.updateAllDrivers();
    } else if (productLineChanged) {
      // Refresh trucks when product line changes (but not when region changes, as that's already handled above)
      this.fetchGeoTraxData();
      this.setAdminCategoryAccess();
      this.updateAllTrucks();
    } else if (userPermissionChanged) {
      this.setAdminCategoryAccess();
      this.fetchPlantList();
    }

    this.updateTicketsOpen();
    const {
      positions: prevPositions,
      showExternalTrucks: prevShowExternal,
      showInternalTrucks: prevShowInternal,
      currentRegion: prevCurrentRegion,
      plantList: prevPlantList,
    } = prevProps;
    const { positions, showExternalTrucks, showInternalTrucks, currentRegion, plantList } =
      this.props;

    const positionsChanged = !isEqual(prevPositions, positions);
    const plantListChanged = !isEqual(prevPlantList, plantList);
    const showExternalChanged = prevShowExternal !== showExternalTrucks;
    const showInternalChanged = prevShowInternal !== showInternalTrucks;
    const currentRegionChanged = prevCurrentRegion !== currentRegion;
    // activeMarkersSelector is product-line aware; the selector output can change
    // even when no other tracked input has (e.g. mid-product-line-switch). DEV-3868.
    const activeMarkersChanged = !isEqual(this.props.activeMarkers, prevProps.activeMarkers);
    if (
      !positionsChanged &&
      !showExternalChanged &&
      !showInternalChanged &&
      !currentRegionChanged &&
      !plantListChanged &&
      !activeMarkersChanged
    ) {
      return;
    }

    const isOnIncomingMaterialsPage =
      this.props.location.pathname.includes(INCOMING_MATERIALS_ROUTE);
    if (activeMarkersChanged && !isOnIncomingMaterialsPage) {
      this.props.setActiveMarkers(this.props.activeMarkers);
    }
  }

  componentWillUnmount() {
    this.clearIntervals();
  }

  updateAllDrivers = () => {
    const allProductLines = [ProductLine.Aggregates, ProductLine.Cement, ProductLine.ReadyMix];
    this.props.setReduxAllDriverList(this.props.currentRegion?.url ?? '', allProductLines, false);
  };

  updateAllTrucks = () => {
    this.props.setReduxAllTruckList(
      this.props.currentRegion?.url ?? '',
      this.props.selectedProductLine,
    );
  };

  updateTicketsOpen = () => {
    const isTicketsSidebar =
      this.props.sidebarSelection?.sidebarTitle === TICKETS_SELECTED ||
      this.props.sidebarSelection?.sidebarTitle === NOTEBOOK_SELECTED ||
      this.props.sidebarSelection?.sidebarTitle === INCOMING_TICKETS_SELECTED;

    const ticketsSidebarHasChanged =
      isTicketsSidebar && this.props.sidebarSelection.isSelected !== this.state.isTicketsOpen;

    if (ticketsSidebarHasChanged) {
      this.setState({
        isTicketsOpen: this.props.sidebarSelection.isSelected,
      });
    }
  };

  async initializePermissions() {
    const bypassCache = this.normalizedAppPath === 'admin';
    await this.props.fetchPermissionsListByUserUrl(this.props.userUrl ?? '', bypassCache);
  }

  /**
   * Handles localStorage changes and updates Redux state accordingly.
   * This ensures that when values change in other tabs/windows, the current app stays in sync.
   */
  handleStorageChange = (event: StorageEvent) => {
    if (!event.key) return;

    switch (event.key) {
      case OPEN_SIDEBAR_MESSAGES: {
        if (event.newValue === 'true') {
          // Remove the local storage variables
          window.localStorage.removeItem(OPEN_SIDEBAR_MESSAGES);
          window.localStorage.removeItem(IS_MESSAGE_WINDOW_OPEN);
          // Open the messages sidebar
          this.props.setSidebarSelected!(MESSAGE_SELECTED, true);
        }
        break;
      }
      case ADMIN_CURRENT_REGION:
      case CURRENT_REGION: {
        const region = getCurrentRegionFromLocalStorage();
        this.props.setCurrentRegion(region);
        break;
      }
      case ADMIN_SELECTED_PRODUCT_LINE:
      case SELECTED_PRODUCT_LINE: {
        const productLine = getProductLineFromLocalStorage() ?? ProductLine.None;
        this.props.setSelectedProductLine(productLine);
        break;
      }
      case SELECTED_PLANT_URLS: {
        this.updatePlantListFromLocalStorage(event.newValue || '[]');
        break;
      }
      default:
        break;
    }
  };

  /**
   * Initializes Redux state from localStorage values on app mount.
   * This ensures the app state is in sync with localStorage from the start.
   */
  initializeFromLocalStorage = () => {
    // Initialize current region
    const currentRegion = getCurrentRegionFromLocalStorage();
    if (currentRegion && currentRegion.url !== this.props.currentRegion?.url) {
      this.props.setCurrentRegion(currentRegion);
    }

    // Initialize selected product line (already handled above, but ensure it's set)
    const selectedProductLine = getProductLineFromLocalStorage();
    if (selectedProductLine && selectedProductLine !== this.props.selectedProductLine) {
      this.props.setSelectedProductLine(selectedProductLine);
    }

    // Initialize selected plant URLs
    const selectedPlantUrls = window.localStorage.getItem(SELECTED_PLANT_URLS);
    if (selectedPlantUrls) {
      this.updatePlantListFromLocalStorage(selectedPlantUrls);
    }
  };

  /**
   * Updates the plantList in Redux mapFilters based on selectedPlantUrls from localStorage.
   * This syncs the selected plants across tabs/windows.
   */
  updatePlantListFromLocalStorage = (urls: string) => {
    const selectedPlantUrls = JSON.parse(urls) as string[];
    const { plantList } = this.props;

    if (!plantList || plantList.length === 0) {
      return;
    }

    // Update plantList to match selectedPlantUrls from localStorage
    const updatedPlantList = plantList.map(plant => ({
      ...plant,
      isSelected: selectedPlantUrls.includes(plant.url ?? ''),
    }));

    // Only update if there's a change
    const hasChange = plantList.some(
      (plant, index) => plant.isSelected !== updatedPlantList[index].isSelected,
    );

    if (hasChange) {
      this.props.toggleMapFilter({ plantList: updatedPlantList });
    }
  };

  socketInit = (defaultRegion: UrlKeyDto, currentSubscription?: any) => {
    messageSocketInit(defaultRegion, currentSubscription);
    ticketSocketInit(defaultRegion, this.props.selectedProductLine);
  };

  startTrucksInterval = () => {
    this.trucksInterval = global.setInterval(() => {
      this.props.refreshPositions();
    }, SIDENAV_REFRESH_IN_MILLISECONDS);
  };

  clearIntervals = () => {
    global.clearInterval(this.trucksInterval!);
  };

  fetchGeoTraxData = () => {
    if (this.props.currentRegion && this.props.geotraxPage) {
      this.props.setReduxDriverList(
        this.props.currentRegion.url!,
        [this.props.selectedProductLine],
        true,
      );
      this.fetchPlantList();
      this.props.fetchUsers('', this.signal.token);
      this.props.getInboxMessages(
        undefined,
        undefined,
        this.props.currentRegion,
        this.props.selectedProductLine,
      );
    }
  };

  fetchPlantList = () => {
    this.props.fetchPlantListAndMapFilters(
      this.props.currentRegion?.url ?? '',
      this.props.selectedProductLine,
      this.props.userUrl || undefined,
    );
  };

  handleModalClose = () => {
    this.props.closeModal();
  };

  handleSnackbarClose = () => {
    this.props.closeSnackbar();
  };

  handleSnackbarNotificationClose = () => {
    this.props.closeSnackbarNotification();
  };

  changeRegion = async (regionUrl: string) => {
    const currentRegion = this.props.regions!.filter(region => region.url === regionUrl)[0];
    const { userUrl, messageSubscription } = this.props;
    const bypassCache = this.normalizedAppPath === 'admin';
    const selectedProductLine = this.props.selectedProductLine ?? ProductLine.None;
    this.props.setSidebarSelected!(MESSAGE_SELECTED, false);
    this.props.refreshGeoTraxState(
      currentRegion,
      selectedProductLine,
      userUrl ?? undefined,
      messageSubscription,
      bypassCache,
    );
  };

  onClick = (item: NavItem) => {
    this.props.geotraxPageSelected!(item);
  };

  openLogOutDialog = () => {
    const modal: ModalOptions = {
      acceptDialog: this.props.logOut,
      modalType: DEFAULT,
      modalBody: 'Are you sure you want to log out?',
      modalTitle: 'Confirm Logout',
      modalOpen: true,
      acceptText: LOGOUT,
      cancelText: CANCEL_LABEL,
      disabled: false,
      noActions: false,
    };
    this.props.openModal(modal);
  };

  static renderAppSubroutes = (puRoute: RouteInfo) => <RouteWithSubRoutes {...puRoute} />;

  static renderSidebarLabels = (route: RouteInfo, index: number) => (
    <Route key={route.key} path={route.path} component={PanelLabelWrapper} />
  );

  getAppProps(categories: { admin: AdminCategory[] }): AppPropsForPanels {
    return {
      ...this.props,
      categories,
      activeTrucks: this.props.activeMarkers,
      changeRegion: this.changeRegion,
      primaryProductLine: this.primaryProductLine ?? ProductLine.None,
      secondaryProductLine: this.secondaryProductLine ?? ProductLine.None,
      secondaryProductLines: this.secondaryProductLines ?? [],
      checkSetOpenStateMap: this.checkSetOpenStateMap,
      userFullName: this.userFullName,
      allTrucks: this.props.allTrucks,
    };
  }

  getAdminPermissionAccessForRegion = (category: { name: string }, currentRegion: string) => {
    let adminPermission = category.name;
    if (category.name === GEOZONES_TEXT) {
      adminPermission = PLANTS_TEXT;
    } else if (category.name === VEHICLE_TYPES_TEXT || category.name === VEHICLES_TEXT) {
      adminPermission = TRUCKS_TEXT;
    }

    return adminPermissionForUserInCurrentRegion(
      this.props.userPermission,
      currentRegion,
      adminPermission,
    );
  };

  /**
   * Sets the visible admin categories based on permissions and feature flags
   */
  setAdminCategoryAccess = () => {
    const currentRegion = this.props.currentRegion ? this.props.currentRegion.url : '';

    const adminCategories = categoriesForAdmin.filter(
      c => this.getAdminPermissionAccessForRegion(c, currentRegion!) !== PermissionAccess.Deny,
    );

    const modifiedAdminCategories = this.applyFeatureFlagsToAdminCategories(adminCategories);
    this.setState({ adminAccess: modifiedAdminCategories ?? adminCategories });
  };

  /**
   * @param flags the list of feature flags
   * @param categories the list of admin categories
   * @returns the modified list of admin categories or undefined if categories has no items
   */
  applyFeatureFlagsToAdminCategories = (
    categories: AdminCategory[],
  ): AdminCategory[] | undefined => {
    if (categories?.length === 0) {
      return undefined;
    }
    const items = [...categories];
    const isTruckTraxGeoEnabled = isFeatureFlagEnabled(
      this.props.userPermission,
      this.props.currentRegion?.url ?? '',
      TRUCKTRAX_GEO_FLAG,
    );
    if (isTruckTraxGeoEnabled) {
      items.splice(
        featureFlagVehicleNavItem.index,
        featureFlagVehicleNavItem.itemsOffset,
        ...featureFlagVehicleNavItem.items,
      );
    }
    return items;
  };

  checkSetOpenStateMap = (stateMap: { [index: number]: boolean }) => {
    if (!isEqual(stateMap, this.props.openStateMap)) {
      this.props.setOpenStateMap(stateMap);
    }
  };

  getFeaturedNavItems() {
    const { location } = this.props;
    const [appPath] = location.pathname.substring(1).split('/');
    switch (appPath.toLowerCase()) {
      case 'admin':
        return adminNavItems;
      case 'geotrax': {
        const isIncomingMaterialsEnabled = isFeatureFlagEnabled(
          this.props.userPermission,
          this.props.currentRegion?.url ?? '',
          INCOMING_MATERIALS_FLAG,
        );
        if (!isIncomingMaterialsEnabled) {
          return geotraxNavItems.filter(item => item.key !== INCOMING_MATERIALS_NAV_KEY);
        }
        // DEV-4154: while on the incoming materials page the notification dot
        // moves to the incoming tickets action button, so the
        // route button drops it.
        if (location.pathname.includes(INCOMING_MATERIALS_ROUTE)) {
          return geotraxNavItems;
        }
        return withIncomingMaterialsNotice(geotraxNavItems);
      }
      default:
        return [];
    }
  }

  getFeaturedAppIcon() {
    switch (this.normalizedAppPath) {
      case 'admin':
        return logoAdminSvg;
      case 'geotrax':
        return logoGeotraxSvg;
      default:
        return '';
    }
  }

  get shouldIncludeMessageActions() {
    const appsWithMessageCenter = ['geotrax'];
    return appsWithMessageCenter.some(app => app === this.normalizedAppPath);
  }

  get shouldIncludeTicketActions() {
    const appsWithTicketing = ['geotrax'];
    return appsWithTicketing.some(app => app === this.normalizedAppPath);
  }

  get shouldIncludeNotebook() {
    const appsWithNotebook = ['scaletrax'];
    return appsWithNotebook.some(app => app === this.normalizedAppPath);
  }

  get shouldIncludeAppSwitcher() {
    const apps: TruckTraxApps[] = [TruckTraxApps.GeoTrax, TruckTraxApps.Admin];
    const accessibleApps = apps.filter(app =>
      hasAppAccessInAnyRegion(app, this.props.userPermission),
    );
    return accessibleApps.length > 1;
  }

  get shouldIncludeSidePanel() {
    const appsWithSidePanel = ['geotrax', 'admin'];
    return (
      appsWithSidePanel.some(app => app === this.normalizedAppPath) ||
      this.props.location.pathname.includes('/scaletrax/docs')
    );
  }

  get normalizedAppPath() {
    const { location } = this.props;
    const [appPath] = location.pathname.substring(1).split('/');
    return appPath.toLocaleLowerCase();
  }

  render() {
    const truckToDriverMap = getTruckToDriverMap(this.props.drivers);

    const emptyItem = {};
    const isOnIncomingMaterials = this.props.location.pathname.includes(INCOMING_MATERIALS_ROUTE);
    let ticketItem = emptyItem;
    if (this.shouldIncludeTicketActions) {
      ticketItem = isOnIncomingMaterials ? incomingTicketingActionItems : ticketingActionItems;
    }
    const notebookItem = this.shouldIncludeNotebook ? notebookActionItems : emptyItem;
    const messageItem = this.shouldIncludeMessageActions ? messagesActionItems : emptyItem;
    const appMenuItem = this.shouldIncludeAppSwitcher ? appSelectorActionItems : emptyItem;
    const actionItems = {
      ...ticketItem,
      ...notebookItem,
      ...messageItem,
      ...appMenuItem,
    };
    const categories = {
      admin: this.state.adminAccess,
    };
    // render sidebar panel inner components
    const appProps = this.getAppProps(categories);
    const sideBarContent: (JSX.Element | undefined)[] = this.props.routes.map(
      renderSidebarInnerComponents(appProps),
    );
    // render sidebar panel labels
    const sideBarLabel = this.props.routes.map(App.renderSidebarLabels);

    // left nav props
    const navProps = {
      onLogout: this.openLogOutDialog,
      onClick: this.onClick,
      appVersion: appVersionAndEnvString(),
      actionItems,
      linkComponent: Link,
      routeComponent: Route,
    };

    const featuredNavItems = this.getFeaturedNavItems();
    const featuredAppIcon = this.getFeaturedAppIcon();
    const leftNav = (
      <LeftNav
        appIcon={featuredAppIcon}
        {...this.props}
        navItems={featuredNavItems}
        panelContent={sideBarContent}
        panelLabel={sideBarLabel}
        sidePanelHidden={!this.shouldIncludeSidePanel}
        {...navProps}
      />
    );

    // render app subroutes
    const configRoutes = this.props.routes.map(App.renderAppSubroutes);

    // add redirect from / to /map
    configRoutes.push(<RedirectRoute {...mapRouteRedirect} />);

    // add redirect from /* to 404
    configRoutes.push(<RedirectRoute {...mapRouteNotFound} />);

    // add redirect from /admin/* to 404
    configRoutes.push(<RedirectRoute {...adminRouteNotFound} />);

    // add redirect for /docs/* to 404
    configRoutes.push(<RedirectRoute {...docsRouteNotFound} />);

    const renderRoutes = () => {
      const mainStyle = this.state.isTicketsOpen ? styles.mainWithTickets : styles.main;

      return (
        <div className={mainStyle}>
          <Switch>{configRoutes}</Switch>
        </div>
      );
    };

    if (this.props.location.pathname === NOT_FOUND_PATH) {
      return (
        <div className={styles.main}>
          <NotFoundView />
        </div>
      );
    }

    if (this.props.location.pathname === MESSAGE_WINDOW) {
      return (
        <div className={styles.layoutContainer}>
          <MessageCenterPopover
            driverList={this.props.drivers}
            currentRegion={this.props.currentRegion}
            trucksToDriversMap={truckToDriverMap}
            selectedProductLine={this.props.selectedProductLine}
          />
        </div>
      );
    }

    return (
      <div className={styles.layoutContainer}>
        <Snackbar
          snackbarBody={this.props.snackbar?.snackbarBody ?? ''}
          snackbarOpen={this.props.snackbar?.snackbarOpen}
          dataTest={this.props.snackbar?.dataTest}
          handleSnackbarClose={this.handleSnackbarClose}
          snackbarType={this.props.snackbar?.snackbarType ?? ''}
          manualClose={this.props.snackbar?.manualClose}
          snackbarBodyElement={this.props.snackbar?.snackbarBodyElement}
        />

        {/* DEV-4154: keeps the IM ticket subscription live across all GeoTrax
            pages so the nav notification dot updates from anywhere */}
        {this.normalizedAppPath === GEOTRAX_ROUTE && <IncomingMaterialsSubscription />}
        {leftNav}
        {renderRoutes()}
        <Modal
          onOK={this.props.acceptDialog}
          acceptText={this.props.acceptText}
          type={this.props.modalType as ModalType}
          body={this.props.modalBody as string}
          title={this.props.modalTitle}
          isOpen={this.props.modalOpen}
          dataTestOk={this.props.dataTestOk}
          dataTestCancel={this.props.dataTestCancel}
          onCancel={this.handleModalClose}
          cancelText={this.props.cancelText}
          disabled={this.props.disabled}
          noActions={this.props.noActions}
          isDeleteConfirmation={this.props.isDeleteConfirmation}
        />
        <Notification
          snackbarNotificationBody={this.props.snackbarNotification?.snackbarNotificationBody ?? {}}
          snackbarNotificationOpen={this.props.snackbarNotification?.snackbarNotificationOpen}
          dataTest={this.props.snackbar?.dataTest}
          handleSnackbarClose={this.handleSnackbarNotificationClose}
        />
        <TicketsPopover history={this.props.history} />
        <IncomingTicketsPopover history={this.props.history} />
        <NotebookPopover />
        <MessageCenterContainer
          driverList={this.props.drivers}
          currentRegion={this.props.currentRegion}
          trucksToDriversMap={truckToDriverMap}
          selectedProductLine={this.props.selectedProductLine}
          selectedPlantUrls={this.props.selectedPlantUrls}
          positions={this.props.positions}
          trucks={this.props.allTrucks}
        />
      </div>
    );
  }
}

export interface AppState {
  adminAccess: AdminCategory[];
  isTicketsOpen: boolean;
}

function mapStateToProps(state: Partial<ReduxState>): AppReduxStateProps {
  return {
    flags: state.flags,
    snackbar: state.snackbar,
    snackbarNotification: state.snackbarNotification,
    closeDialog: state.openModal?.closeDialog,
    acceptDialog: state.openModal?.acceptDialog,
    acceptText: state.openModal?.acceptText,
    modalType: state.openModal?.modalType,
    modalBody: state.openModal?.modalBody as string,
    modalTitle: state.openModal?.modalTitle,
    modalOpen: state.openModal?.modalOpen,
    isDeleteConfirmation: state.openModal?.isDeleteConfirmation,
    dataTestCancel: state.openModal?.dataTestCancel,
    dataTestOk: state.openModal?.dataTestOk,
    messageSubscription: state.messageSubscription,
    regions: state.assignedRegionList as any,
    currentRegion: state.currentRegion as any,
    positions: state.positionList,
    showInternalTrucks: state.mapFilters?.showTrucks,
    showExternalTrucks: state.mapFilters?.showExtTrucks,
    plantList: state.mapFilters?.plantList,
    messageCenter: state.messages,
    drivers: getDriversWithDetails(state as ReduxState),
    selectedMarker: state.selectedMarker,
    currentTicketQualityFactors: state.currentTicketQualityFactors ?? [],
    sidebarSelection: state.sidebar,
    trucksDropdownIsOpen: state.trucksDropdownIsOpen ?? false,
    externalTrucksDropdownIsOpen: state.externalTrucksDropdownIsOpen ?? false,
    guideDropdownIsOpen: state.guideDropdownIsOpen ?? false,
    openStateMap: state.openStateMap ?? {},
    selectedProductLine: state.selectedProductLine ?? state.primaryProductLine ?? ProductLine.None,
    primaryProductLine: state.primaryProductLine ?? ProductLine.None,
    secondaryProductLine: state.secondaryProductLine ?? ProductLine.None,
    secondaryProductLines: [ProductLine.Cement],
    userPermission: state.userPermission || {},
    idleTime: state.minutesToIdleLogout,
    sessionId: state.sessionId ?? null,
    userUrl: state.userUrl ?? null,
    userFullName: state.userFullName ?? null,
    cancelText: state.openModal?.cancelText || CANCEL_LABEL,
    disabled: state.openModal?.disabled || false,
    noActions: state.openModal?.noActions || false,
    geotraxPage: state.geotraxPage,
    isTruckTraxGeoEnabled: isFeatureFlagEnabled(
      state.userPermission ?? {},
      state.currentRegion?.url ?? '',
      TRUCKTRAX_GEO_FLAG,
    ),
    allTrucks: state.allTrucks ?? [],
    allDrivers: getAllDriversWithDetails(state as ReduxState),
    selectedPlantUrls: selectedPlantUrlsSelector(state),
    activeMarkers: activeMarkersSelector(state as ReduxState),
  };
}

export interface AppReduxStateProps {
  flags: any;
  snackbar?: SnackbarState;
  snackbarNotification?: SnackbarNotificationState;
  closeDialog?: () => void;
  acceptDialog?: () => void;
  acceptText?: string;
  modalType?: NotificationType;
  modalBody: string;
  modalTitle?: string;
  modalOpen?: boolean;
  isDeleteConfirmation?: boolean;
  dataTestCancel?: string;
  dataTestOk?: string;
  messageSubscription?: { unsubscribe: () => void }[];
  regions?: RegionDto[];
  currentRegion?: UserRegionDto & { name: string };
  showInternalTrucks?: boolean;
  showExternalTrucks?: boolean;
  plantList?: PlantFilterOption[] | undefined;
  positions?: PositionDetailsDto[];
  messageCenter?: MessageCenterState;
  drivers: DriverDetail[];
  allDrivers: DriverDto[];
  allTrucks: TruckDto[];
  selectedMarker?: Partial<MarkerInfo>;
  activeMarkers: MapMarker[];
  currentTicketQualityFactors: QualityFactorDto[];
  sidebarSelection?: SidebarSelection;
  trucksDropdownIsOpen: boolean;
  externalTrucksDropdownIsOpen: boolean;
  guideDropdownIsOpen: boolean;
  openStateMap: { [index: number]: boolean };
  selectedProductLine: ProductLine;
  primaryProductLine: ProductLine;
  secondaryProductLine: ProductLine;
  secondaryProductLines: ProductLine[];
  userPermission: RegionAccessMap;
  idleTime?: number;
  sessionId: string | null;
  userUrl: string | null;
  userFullName: string | null;
  cancelText: string;
  disabled: boolean;
  noActions: boolean;
  geotraxPage?: NavItem;
  isTruckTraxGeoEnabled: boolean;
  selectedPlantUrls: string[];
}
export interface AppOwnProps {
  history: {
    push: () => void;
  };
  routes: RouteInfo[];
  location: {
    pathname: string;
  };
}

export type AppProps = AppReduxStateProps & AppOwnProps & AppDispatchProps;

export interface AppDispatchProps {
  updateMap: () => void;
  openModal: (options: ModalOptions) => void;
  closeModal: () => void;
  openSnackbar: (options: SnackbarOptions) => void;
  closeSnackbar: () => void;
  closeSnackbarNotification: () => void;
  logOut: () => void;

  fetchAssignedRegionList: (
    socketInitCallback: (defaultRegion: UrlKeyDto, currentSubscription?: any) => void,
    getMapviewsCallback: (regionUrl: string) => void,
  ) => void;
  selectMarker: (truck: MarkerInfo, fromTickets: boolean) => void;
  setActiveMarkers: (markers: MapMarker[]) => void;
  setReduxDriverList: (
    regionUrl: string,
    productLines: ProductLine[],
    bypassCache?: boolean,
  ) => void;
  setReduxAllDriverList: (
    regionUrl: string,
    productLines: ProductLine[],
    bypassCache?: boolean,
  ) => void;
  setReduxTruckList: (
    haulerUrl?: string,
    regionUrl?: string,
    productLine?: string,
    productLines?: string,
  ) => void;
  setReduxAllTruckList: (regionUrl?: string, productLine?: string) => void;
  fetchPlantListAndMapFilters: (
    regionUrl: string,
    productLine: ProductLine,
    userUrl?: string,
  ) => void;
  fetchUsers: ConnectedDispatchFunction<typeof fetchUsers>;
  setOpenStateMap: (map: { [index: number]: boolean }) => void;
  toggleTrucksDropdownIsOpen: () => void;
  toggleExternalTrucksDropdownIsOpen: () => void;
  toggleGuideDropdownIsOpen: () => void;
  refreshPositions: () => void;
  setPrimaryProductLine: (productLine: ProductLine) => void;
  setSecondaryProductLine: (productLine: ProductLine) => void;
  setSecondaryProductLines: (productLines: ProductLine[]) => void;
  setSelectedProductLine: (productline: ProductLine) => void;
  getInboxMessages: (
    page?: number,
    messageList?: [],
    currentRegion?: UrlKeyDto | string,
    selectedProductLine?: string,
  ) => void;
  setCurrentRegion: (region: UrlKeyDto | string) => void;
  toggleMapFilter: (filterObject: Partial<any>) => void;
  fetchPermissionsListByUserUrl: (userUrl: string, bypassCache?: boolean) => void;
  setSessionId: (sessionId: string) => void;
  getMapview: (regionUrl: string) => void;
  setCurrentAppName: ConnectedFunction<typeof setCurrentAppName>;
  setSidebarSelected?: (sidebarTitle: SidebarTitleType, isSelected: boolean) => void;
  geotraxPageSelected?: (page: NavItem) => void;
  setUserFullName: (userFullName: string) => void;
  refreshGeoTraxState: (
    region?: { url?: string; name?: string },
    productLine?: ProductLine,
    userUrl?: string,
    messageSubscriptions?: {
      url?: string;
      unsubscribe: VoidFunc;
    }[],
    bypassCache?: boolean,
  ) => void;
}

const dispatchMappedToProps: AppDispatchProps = {
  updateMap: getMapview,
  getMapview,
  openModal,
  closeModal,
  openSnackbar,
  closeSnackbar,
  closeSnackbarNotification,
  fetchAssignedRegionList,
  logOut,
  setCurrentAppName,
  selectMarker,
  setActiveMarkers,
  setReduxDriverList,
  setReduxAllDriverList,
  setReduxTruckList,
  setReduxAllTruckList,
  fetchPlantListAndMapFilters,
  fetchUsers,
  setOpenStateMap,
  toggleTrucksDropdownIsOpen,
  toggleExternalTrucksDropdownIsOpen,
  toggleGuideDropdownIsOpen,
  refreshPositions,
  setSecondaryProductLine,
  setSecondaryProductLines,
  setPrimaryProductLine,
  setSelectedProductLine,
  getInboxMessages,
  setCurrentRegion,
  toggleMapFilter,
  fetchPermissionsListByUserUrl,
  setSessionId,
  setSidebarSelected,
  geotraxPageSelected,
  setUserFullName,
  refreshGeoTraxState,
} as any;

export default connect<AppReduxStateProps, AppDispatchProps>(
  state => mapStateToProps(state),
  dispatchMappedToProps,
)(App);

export interface AppPropsForPanels extends AppProps {
  categories: { admin: AdminCategory[] };
  activeTrucks: MapMarker[];
  allTrucks: TruckDto[];
  isTruckTraxGeoEnabled: boolean;
  changeRegion: (regionUrl: string) => Promise<void>;
  checkSetOpenStateMap: (map: { [index: number]: boolean }) => void;
}
